import type { PortfolioWindowParams } from "./types";

/** organisation-power's window, exactly as the Portfolio page sends it. */
export interface PortfolioLiveRange {
  /** metricsTimeStamps.fromTimestamp: a UTC instant. */
  fromTimestamp: string;
  /** metricsEndDate: a UTC instant. */
  toTimestamp: string;
}

/**
 * The portfolio query's window: the very instants organisation-power is sent, and the same
 * aggregates basis (spec §3.1, §3.2).
 *
 * Nothing is mapped, trimmed or recovered, and no timezone decision is made here. The API
 * widens each property's window to the whole property-local days that contain these
 * instants, in that property's own timezone, exactly as live's DAILY read does, so a preset
 * and a custom range need no different handling. `useV2` is the basis organisation-power
 * reads (useAggregatesV2Query's rule); on V1 the API answers `liveFallback`.
 */
export function toPortfolioWindowParams(range: PortfolioLiveRange, useV2: boolean): PortfolioWindowParams {
  return { fromTimestamp: range.fromTimestamp, toTimestamp: range.toTimestamp, useV2 };
}
